import axios from 'axios';
import {
  GET_MOVIES_FILTER,
  GET_FILTERED_MOVIES,
  CLEAR_FILTERED_MOVIES,
  GET_MOVIE,
  GET_MOVIE_EPISODES,
  GET_MOVIE_THREAD,
  CLEAR_MOVIE_DATA,
  GET_NEW_MOVIES,
  GET_LAST_MOVIES,
  GET_TOP_MOVIES,
  GET_RECOMMENDED_MOVIES,
} from '../constants';

export const getMoviesFilterSuccess = response => ({
  type: GET_MOVIES_FILTER,
  response,
});

export const getMoviesFilter = () => dispatch => (
  axios.get('/videos/movies/filter')
    .then((response) => {
      const data = {
        status: response.status,
        data: response.data.data,
      };
      return dispatch(getMoviesFilterSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getMoviesFilterSuccess(data));
    })
);

export const getFilteredMoviesSuccess = response => ({
  type: GET_FILTERED_MOVIES,
  response,
});

export const getFilteredMovies = (page = 1, genre = '', country = '', year = '', language = '') => dispatch => (
  axios.get(`/videos/movies?page=${page}&size=12&genre=${genre}&country=${country}&year=${year}&language=${language}`)
    .then((response) => {
      const data = {
        status: response.status,
        pageLoaded: page,
        hasNext: response.data.pages !== 0 && response.data.pages !== page,
        data: response.data.data,
      };
      return dispatch(getFilteredMoviesSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getFilteredMoviesSuccess(data));
    })
);

export const clearFilteredMovies = () => ({
  type: CLEAR_FILTERED_MOVIES,
});

export const clearMovieData = () => ({
  type: CLEAR_MOVIE_DATA,
});

export const getMovieThreadSuccess = response => ({
  type: GET_MOVIE_THREAD,
  response,
});

export const getMovieThread = id => dispatch => (
  axios.get(`/videos/media/thread/${id}`)
    .then((response) => {
      const data = {
        status: response.status,
        data: response.data.data,
      };
      return dispatch(getMovieThreadSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
        data.data = error.response.data;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getMovieThreadSuccess(data));
    })
);

export const getMovieEpisodesSuccess = response => ({
  type: GET_MOVIE_EPISODES,
  response,
});

export const getMovieEpisodes = id => dispatch => (
  axios.get(`/videos/movie/episodes/${id}?size=100`)
    .then((response) => {
      dispatch(getMovieThread(response.data.data[0].id));
      const data = {
        status: response.status,
        data: response.data.data.reverse(),
      };
      return dispatch(getMovieEpisodesSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: (error.response && error.response.data) || [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getMovieEpisodesSuccess(data));
    })
);

export const getMovieSuccess = response => ({
  type: GET_MOVIE,
  response,
});

export const getMovie = id => dispatch => (
  axios.get(`/videos/movie/${id}`)
    .then((response) => {
      dispatch(getMovieEpisodes(response.data.data.seasons[0].id));
      const data = {
        status: response.status,
        data: response.data.data,
      };
      return dispatch(getMovieSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: {},
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getMovieSuccess(data));
    })
);

export const getNewMoviesSuccess = response => ({
  type: GET_NEW_MOVIES,
  response,
});

export const getNewMovies = (page = 1, size = 15) => dispatch => (
  axios.get(`/videos/movies?order=new&page=${page}&size=${size}`)
    .then((response) => {
      const data = {
        status: response.status,
        pageLoaded: page,
        hasNext: response.data.pages !== page,
        data: response.data.data,
      };
      return dispatch(getNewMoviesSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getNewMoviesSuccess(data));
    })
);


export const getLastMoviesSuccess = response => ({
  type: GET_LAST_MOVIES,
  response,
});

export const getLastMovies = (page = 1, size = 15) => dispatch => (
  axios.get(`/videos/movies?order=last&page=${page}&size=${size}`)
    .then((response) => {
      const data = {
        status: response.status,
        pageLoaded: page,
        hasNext: response.data.pages !== page,
        data: response.data.data,
      };
      return dispatch(getLastMoviesSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getLastMoviesSuccess(data));
    })
);

export const getTopMoviesSuccess = response => ({
  type: GET_TOP_MOVIES,
  response,
});

export const getTopMovies = (page = 1, size = 15) => dispatch => (
  axios.get(`/videos/movies?order=top&page=${page}&size=${size}`)
    .then((response) => {
      const data = {
        status: response.status,
        pageLoaded: page,
        hasNext: response.data.pages !== page,
        data: response.data.data,
      };
      return dispatch(getTopMoviesSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getTopMoviesSuccess(data));
    })
);


export const getRecommendedMoviesSuccess = response => ({
  type: GET_RECOMMENDED_MOVIES,
  response,
});

export const getRecommendedMovies = (page = 1, size = 15) => dispatch => (
  axios.get(`/videos/movies?order=recommend&page=${page}&size=${size}`)
    .then((response) => {
      const data = {
        status: response.status,
        pageLoaded: page,
        hasNext: response.data.pages !== page,
        data: response.data.data,
      };
      return dispatch(getRecommendedMoviesSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getRecommendedMoviesSuccess(data));
    })
);
